export const BASE_CONSULTATION_PATH = '/consultations';

export const INDEX_CONSULTATION_PATH = `${ BASE_CONSULTATION_PATH }/all`;
export const NEW_CONSULTATION_PATH = `${ BASE_CONSULTATION_PATH }/new`;
export const EDIT_CONSULTATION_PATH = `${ BASE_CONSULTATION_PATH }/edit/:id`;
